import { render, staticRenderFns } from "./FuelSurchargeForm.vue?vue&type=template&id=6284ce6a"
import script from "./FuelSurchargeForm.vue?vue&type=script&lang=js"
export * from "./FuelSurchargeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports